<template>
  <div class="flex stock-board justify-between" v-loading="loading">

    <div class="card-box flex justify-between">

      <div class="flex card-box-line" style="margin-bottom: 6px;">
        <div class="stock-card flex align-center" style="padding-left: 16px">
          <div class="stock-card-icon bgBlue flex align-center justify-center">
            <i class="iconfont iconkucun colorBlue"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">总库存</div>
            <div class="size20" style="font-weight: bold;line-height: 30px;">
              <gj-tooltip
                  :content="amountSymbol(data.totalQuantity).origin"
              >
                {{ getPrice(data.totalQuantity, '') }}
              </gj-tooltip>
              <!--              {{ amountSymbol(data.totalQuantity, 0).origin | defaultShow }}-->
            </div>
          </div>
        </div>

        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgBlue flex align-center justify-center">
            <i class="iconfont iconkucun colorBlue"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">总货值{{data.currencySymbol | defaultShow('(',')','')}}</div>
            <div class="size20" style="font-weight: bold;line-height: 30px;">
              <gj-tooltip
                  :content="amountSymbol(data.totalPrice).origin"
              >
                {{ getPrice(data.totalPrice) }}
              </gj-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div class="flex card-box-line" style="margin-top: 6px;">
        <div class="stock-card flex align-center" style="padding-left: 16px">
          <div class="stock-card-icon bgBlue flex align-center justify-center">
            <i class="iconfont iconkucun colorBlue"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">滞销率</div>
            <div class="size20" style="font-weight: bold;line-height: 30px;">
              {{ data.fbaUnsalableRate | defaultShow('','%') }}
            </div>
          </div>
        </div>

        <div class="stock-card flex align-center">
          <div class="stock-card-icon bgBlue flex align-center justify-center">
            <i class="iconfont iconkucun colorBlue"></i>
          </div>
          <div style="padding-left: 12px;">
            <div class="size14 color666" style="line-height: 20px;">滞销货值{{data.currencySymbol | defaultShow('(',')','')}}</div>
            <div class="size20" style="font-weight: bold;line-height: 30px;">
              <gj-tooltip
                  :content="amountSymbol(data.fbaUnsalableAmount).origin"
              >
                {{ getPrice(data.fbaUnsalableAmount) }}
              </gj-tooltip>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="list-box size12" style="margin-left: 15px;">
      <div class="list-header color666 flex">
        <div class="col1">FBA仓</div>
        <div class="col2">数量</div>
        <div class="col3">/&nbsp;货值{{data.currencySymbol | defaultShow('(',')','')}}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">待出运</div>
        <div class="col2">{{ getNum(data.fbaWaitShipmentQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.fbaWaitShipmentAmount) }}
        </div>
      </div>
      <div class="list-item flex">
        <div class="col1">在途</div>
        <div class="col2">{{ getNum(data.fbaTransitQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.fbaTransitAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">可售</div>
        <div class="col2">{{ getNum(data.fbaFulfillableQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.fbaFulfillableAmount) }}
        </div>
      </div>
      <div class="list-item flex">
        <div class="col1">预占</div>
        <div class="col2">{{ getNum(data.fbaReservedQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.fbaReservedAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">不可售</div>
        <div class="col2">{{ getNum(data.fbaUnsellableQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.fbaUnsellableAmount) }}</div>
      </div>
    </div>

    <div class="list-box size12" style="margin-left: 20px;">
      <div class="list-header color666 flex">
        <div class="col1">自营仓</div>
        <div class="col2">数量</div>
        <div class="col3">/&nbsp;货值{{data.currencySymbol | defaultShow('(',')','')}}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">可用量</div>
        <div class="col2">{{ getNum(data.selfAvailableQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.selfAvailableAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">次品量</div>
        <div class="col2">{{ getNum(data.selfUnsellableQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.selfUnsellableAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">预占</div>
        <div class="col2">{{ getNum(data.selfReservedQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.selfReservedAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">入库中</div>
        <div class="col2">{{ getNum(data.selfInboundingQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.selfInboundingAmount) }}</div>
      </div>
      <div class="list-item flex">
        <div class="col1">已下单</div>
        <div class="col2">{{ getNum(data.selfAlreadyOrderQuantity) }}</div>
        <div class="col3">/&nbsp;{{ getPrice(data.selfAlreadyOrderAmount) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {amountSymbol, defaultShow} from "@/filters";
import {getStockBoard} from "@/api/dashboard";
import {isMeaningful, isMeaningless} from "@/utils/common";
import {dashboardMixin, queryMixin} from "@/minxins";
import {mapGetters} from "vuex";

export default {
  name: "stock-board",
  mixins: [queryMixin, dashboardMixin],
  data() {
    return {
      loading: false,
      data: {}
    }
  },
  computed:{
    filter() {
      return {
        dateTime: this.timezoneText,
        currency: this.dashboardCurrency,
      }
    }
  },
  methods: {
    amountSymbol,
    defaultShow,
    getNum(val) {
      let num = amountSymbol(val)
      if (num.unit) {
        return defaultShow(amountSymbol(val).value + amountSymbol(val).unit)
      } else {
        return defaultShow(amountSymbol(val).originNum)
      }

    },
    getPrice(val) {
      if(val){
        return amountSymbol(val).value + amountSymbol(val).unit
      }else {
        return '-'
      }

    },
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      // 缓存了时区时，第一次不请求
      if (isMeaningful(this.timezoneId) && isMeaningless(this.timezoneText)) {
        return
      }
      this.loading = true;
      getStockBoard({addInboundingPrice: false, currency: this.dashboardCurrency}).then(data => {
        this.data = data
      }).complete(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.iconfont {
  font-size: 22px;
}

.stock-board {
  height: 252px;

  .card-box {
    width: 360px;
    flex-direction: column;

    .card-box-line {
      flex: 1;
      border: 1px solid #EEEFF0;
      border-radius: 2px;

    }
  }

  .list-box {
    flex: 1;
    border: 1px solid #EEEFF0;
    border-radius: 2px;

    .list-header {
      height: 35px;
      background-color: #F6F8FB;
      padding: 0 16px;
      line-height: 35px;
    }

    .list-item {
      height: 42px;
      padding: 0 16px;
      line-height: 42px;
    }

    .list-item + .list-item {
      border-top: 1px solid #EEEFF0;
    }

    .col1 {
      flex: 1;
    }

    .col2 {
      flex: 1.2;
      text-align: right;
      padding-right: 4px;
    }

    .col3 {
      flex: 1.6;
    }
  }
}

.stock-card {
  box-sizing: border-box;
  width: 50%;
  flex: none;

  .stock-card-icon {
    width: 52px;
    height: 52px;
    border-radius: 8px;
  }

}
</style>